import React, { useState } from "react";
import { Box, Grid, Heading } from "grommet";
import { HeaderArea } from "../components/header-area/index";
import { ProcessComponent } from "../components/pseudonymizer/process";
import { Table } from "../components/table/table";
import { DownloadButton } from "../components/download/download-button";
import { AlgorithmCard } from "../components/algorithm-card/algorithm-card";
import { Footer } from "../components/footer";

export function AuthenticatedApp({ signOut }: any): React.ReactElement {
  const [data, setData] = useState<any[]>([]);
  const [selectedModel, setSelectedModel] = useState<any>({});
  const [progress, setProgress] = useState("Start by selecting some data");

  return (
    <Box fill margin="auto">
      <Grid
        rows={["80px", "flex", "40px"]}
        columns={["260px", "auto", "260px"]}
        gap={{
          row: "small",
          column: "40px",
        }}
        pad={{ horizontal: "40px", bottom: "40px" }}
        areas={[
          { name: "header", start: [0, 0], end: [2, 0] },
          { name: "right-sidebar", start: [2, 1], end: [2, 2] },
          { name: "left-sidebar", start: [0, 1], end: [0, 1] },
          { name: "main", start: [1, 1], end: [1, 2] },
          { name: "sign-out", start: [0, 2], end: [0, 2] },
        ]}
        fill={true}
      >
        <HeaderArea />
        <Box gridArea="left-sidebar" overflow="scroll">
          <ProcessComponent
            data={data}
            setData={setData}
            selectedModel={selectedModel}
            setSelectedModel={setSelectedModel}
            setProgress={setProgress}
          />
        </Box>
        <Box gridArea="main" align="center" gap="medium" fill>
          <Heading level={4} margin="none" textAlign="center">
            Review the files
          </Heading>
          <Table data={data} progress={progress} />
        </Box>
        <Box gridArea="right-sidebar" justify="start">
          <AlgorithmCard selectedModel={selectedModel} />
          <Box fill justify="center" align="center">
            <DownloadButton data={data} />
          </Box>
        </Box>
        <Footer signOut={signOut} />
      </Grid>
    </Box>
  );
}
